module.exports = __webpack_public_path__ + "static/media/platform_container.8f41e870.svg";